/** MIME type carrying a token's raw string during a native drag from the palette into the editor. */
export const TOKEN_DND_MIME = "application/x-template-token";

/**
 * MIME type carrying a token's *id* during a native drag. Parameterized tokens can't build a raw at
 * drag-start, so their drag carries the id instead; the drop handler resolves it to a definition and
 * opens the collector to gather params before inserting.
 */
export const TOKEN_ID_DND_MIME = "application/x-template-token-id";
